import React from "react";
import Image from "../../../components/Image";

// TODO: Move to /components
const YocoMerchant = ({ avatar, merchantName, paragraph }) => (
  <div className={"col-md-4"}>
    <p>{avatar && <Image src={avatar} />}</p>
    <p>{paragraph}</p>
    <h2>{merchantName}</h2>
  </div>
);

export default YocoMerchant;



// WEBPACK FOOTER //
// ./src/pages/za/integrations/yocoMerchant.js